import {
  applyMiddleware, createStore, Reducer, Store,
} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createHashHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware, { Saga, Task } from 'redux-saga';
import { rootSaga } from './root-saga';

import { createRootReducer, InjectedReducers } from './reducers';

export interface InjectableStore extends Store {
  injectedReducers: InjectedReducers;
  injectedSagas: Record<string, Task>;
  injectReducer: (key: string, reducer: Reducer) => void;
  injectSaga: (key: string, saga: Saga) => Task;
}

export const history = createHashHistory({
  hashType: 'slash',
  getUserConfirmation: (message, callback) => callback(window.confirm(message)),
});

export default function configureStore(): InjectableStore {
  const sagaMiddleware = createSagaMiddleware();

  const middleware = [routerMiddleware(history), sagaMiddleware];
  // if (process.env.NODE_ENV === 'development') {
  //   const loggerMiddleware = configureLogger();

  //   middleware = [...middleware, loggerMiddleware];
  // } else {
  //   middleware = [...middleware];
  // }

  const store = createStore(
    createRootReducer(history),
    composeWithDevTools(applyMiddleware(...middleware)),
  ) as InjectableStore;

  store.injectedReducers = {};
  store.injectedSagas = {};
  store.injectReducer = (key, reducer) => {
    if (store.injectedReducers[key] === reducer) return;
    store.injectedReducers[key] = reducer;
    store.replaceReducer(createRootReducer(history, store.injectedReducers));
  };
  store.injectSaga = (key, saga) => {
    const runningSaga = store.injectedSagas[key];
    if (runningSaga) return runningSaga;
    const task = sagaMiddleware.run(saga);
    store.injectedSagas[key] = task;
    return task;
  };

  sagaMiddleware.run(rootSaga);

  return store;
}

export const store = configureStore();
